import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Maximize2, X } from 'lucide-react';
import '../styles/HomamPortal.css';

export const SANCTUM_DARSHAN_IMAGES = [
  {
    id: 'sanctum-arch',
    src: '/images/gallery/saibaba4.jpg',
    alt: 'Sri Gnana Sai Baba Mandir Sanctum Darshan with Grand Floral Arch',
    title: 'Sanctum Alankaram',
    tag: '👑 Full Sanctum Throne',
    desc: 'Sri Gnana Sai Baba seated on the golden throne with sacred floral arch'
  },
  {
    id: 'moola-vigraha',
    src: '/images/gallery/saibaba1.jpg',
    alt: 'Sri Sai Baba Divine Alankaram with Silver Crown & Sacred Rose Garlands',
    title: 'Divine Mukut Alankaram',
    tag: '✨ Silver Om Mukut',
    desc: 'Close-up darshan of Baba adorned with silver Om crown and floral garlands'
  },
  {
    id: 'sai-padam',
    src: '/images/gallery/saibaba34.jpg',
    alt: 'Sri Sai Baba Holy Lotus Feet Darshan with Sacred Tulasi & Golden Cloth',
    title: 'Sri Sai Holy Lotus Feet',
    tag: '🌸 Holy Lotus Feet',
    desc: 'Consecrated lotus feet of Sri Gnana Sai Baba resting in holy Tulasi leaves'
  }
];

export function HomamSanctumDarshan() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);

  const openPhoto = (idx) => {
    setSelectedPhotoIndex(idx);
    setLightboxOpen(true);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedPhotoIndex((prev) => (prev > 0 ? prev - 1 : SANCTUM_DARSHAN_IMAGES.length - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedPhotoIndex((prev) => (prev < SANCTUM_DARSHAN_IMAGES.length - 1 ? prev + 1 : 0));
  };

  const activePhoto = SANCTUM_DARSHAN_IMAGES[selectedPhotoIndex];

  return (
    <>
      {/* ================= UNIQUE SACRED BENTO COLLAGE ================= */}
      <div className="homam-darshan-collage-wrapper">
        {/* Top Header Strip */}
        <div className="homam-collage-header">
          <div className="homam-collage-header-left">
            <span className="homam-collage-om-symbol">ॐ</span>
            <div>
              <h3 className="homam-collage-title">Sacred Sanctum Darshan</h3>
              <p className="homam-collage-subtitle">Sri Gnana Sai Baba Mandir • 3 Divine Perspectives</p>
            </div>
          </div>
        </div>

        {/* The Asymmetrical 3-Photo Bento Collage Grid */}
        <div className="homam-collage-grid">
          {/* Tile 1: Tall Sanctum Throne (Hero Portrait Left) */}
          <div
            className="homam-collage-tile homam-collage-tile-hero"
            onClick={() => openPhoto(0)}
            title="Click to view full-size Sanctum Throne Darshan"
          >
            <img
              src={SANCTUM_DARSHAN_IMAGES[0].src}
              alt={SANCTUM_DARSHAN_IMAGES[0].alt}
              className="homam-collage-img"
              loading="lazy"
            />
            {/* Floating Glassmorphism Badge & Expand Button */}
            <div className="homam-collage-tile-top">
              <span className="homam-collage-glass-badge">
                {SANCTUM_DARSHAN_IMAGES[0].tag}
              </span>
              <button
                type="button"
                className="homam-collage-expand-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  openPhoto(0);
                }}
                title="View High-Definition"
              >
                <Maximize2 className="w-3.5 h-3.5" />
              </button>
            </div>
            {/* Bottom Caption Overlay */}
            <div className="homam-collage-tile-bottom">
              <h4>{SANCTUM_DARSHAN_IMAGES[0].title}</h4>
              <p>{SANCTUM_DARSHAN_IMAGES[0].desc}</p>
            </div>
          </div>

          {/* Right Side Stack: 2 Landscape Tiles */}
          <div className="homam-collage-side-stack">
            {/* Tile 2: Divine Crown Moola Vigraha (Top Right) */}
            <div
              className="homam-collage-tile homam-collage-tile-sub"
              onClick={() => openPhoto(1)}
              title="Click to view full-size Divine Mukut Alankaram"
            >
              <img
                src={SANCTUM_DARSHAN_IMAGES[1].src}
                alt={SANCTUM_DARSHAN_IMAGES[1].alt}
                className="homam-collage-img"
                loading="lazy"
              />
              <div className="homam-collage-tile-top">
                <span className="homam-collage-glass-badge">
                  {SANCTUM_DARSHAN_IMAGES[1].tag}
                </span>
                <button
                  type="button"
                  className="homam-collage-expand-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPhoto(1);
                  }}
                  title="View High-Definition"
                >
                  <Maximize2 className="w-3.5 h-3.5" />
                </button>
              </div>
              <div className="homam-collage-tile-bottom">
                <h4>{SANCTUM_DARSHAN_IMAGES[1].title}</h4>
                <p>{SANCTUM_DARSHAN_IMAGES[1].desc}</p>
              </div>
            </div>

            {/* Tile 3: Sri Sai Holy Lotus Feet (Bottom Right) */}
            <div
              className="homam-collage-tile homam-collage-tile-sub"
              onClick={() => openPhoto(2)}
              title="Click to view full-size Holy Lotus Feet"
            >
              <img
                src={SANCTUM_DARSHAN_IMAGES[2].src}
                alt={SANCTUM_DARSHAN_IMAGES[2].alt}
                className="homam-collage-img"
                loading="lazy"
              />
              <div className="homam-collage-tile-top">
                <span className="homam-collage-glass-badge">
                  {SANCTUM_DARSHAN_IMAGES[2].tag}
                </span>
                <button
                  type="button"
                  className="homam-collage-expand-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    openPhoto(2);
                  }}
                  title="View High-Definition"
                >
                  <Maximize2 className="w-3.5 h-3.5" />
                </button>
              </div>
              <div className="homam-collage-tile-bottom">
                <h4>{SANCTUM_DARSHAN_IMAGES[2].title}</h4>
                <p>{SANCTUM_DARSHAN_IMAGES[2].desc}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Auspicious Benediction Ribbon */}
        <div className="homam-collage-footer">
          <div className="homam-collage-footer-content">
            <span className="homam-collage-diya">🪔</span>
            <span>
              Consecrated Sanctum Darshan • Sri Gnana Sai Baba Mandir 27 Nakshatra Maha Homam
            </span>
          </div>
        </div>
      </div>

      {/* ================= LIGHTBOX MODAL FOR FULL-HD VIEW ================= */}
      {lightboxOpen && (
        <div
          className="homam-darshan-lightbox-overlay"
          onClick={() => setLightboxOpen(false)}
        >
          <div
            className="homam-darshan-lightbox-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="homam-darshan-lightbox-close"
              onClick={() => setLightboxOpen(false)}
              aria-label="Close"
            >
              <X className="w-5 h-5 text-white" />
            </button>

            <div className="homam-darshan-lightbox-stage">
              <img
                src={activePhoto.src}
                alt={activePhoto.alt}
                className="homam-darshan-lightbox-img"
              />
            </div>

            <div className="homam-darshan-lightbox-footer">
              <div>
                <h4 style={{ margin: 0, color: '#f5c542', fontSize: 16, fontWeight: 800 }}>
                  {activePhoto.title}
                </h4>
                <p style={{ margin: '3px 0 0 0', color: '#cbd5e1', fontSize: 13 }}>
                  {activePhoto.desc}
                </p>
              </div>
              <div className="homam-darshan-lightbox-nav">
                <button
                  type="button"
                  onClick={handlePrev}
                  className="homam-darshan-lb-arrow"
                  aria-label="Previous"
                >
                  <ChevronLeft className="w-5 h-5 text-white" />
                </button>
                <span style={{ color: '#94a3b8', fontSize: 13, fontWeight: 700 }}>
                  {selectedPhotoIndex + 1} / {SANCTUM_DARSHAN_IMAGES.length}
                </span>
                <button
                  type="button"
                  onClick={handleNext}
                  className="homam-darshan-lb-arrow"
                  aria-label="Next"
                >
                  <ChevronRight className="w-5 h-5 text-white" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HomamSanctumDarshan;
